import { useTranslation } from 'react-i18next';

import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import { SubscriptionPricingFormFields } from '../../../styledComponents/SubscriptionFormPage/FormSections/AirAmbulanceSubscription/SubscriptionPricingForm/subscriptionPricingForm.models';
import { useEditSRSubscriptionPage } from './editSRSubscriptionPage.hooks';
import EditSRSubscriptionForm from './EditSRSubscriptionForm/EditSRSubscriptionForm';

const EditSRSubscriptionPage = () => {
  const { t } = useTranslation();
  const {
    organizationName,
    subscriptionType,
    loadDatesForNewSubscriptionHandler,
  } = useEditSRSubscriptionPage();

  return (
    <FormErrorProvider
      initErrorGroups={[SubscriptionPricingFormFields.Pricing]}
    >
      <AddContractModal />
      <Header
        title={t('headers.edit-product-subscription', {
          organizationName,
          subscriptionType,
        })}
      />

      <EditSRSubscriptionForm
        onContractChanged={loadDatesForNewSubscriptionHandler}
      />
    </FormErrorProvider>
  );
};

export default EditSRSubscriptionPage;
